module.exports = __webpack_public_path__ + "media/images/theme/default/lab-book-logo-d692c2373914263ba97caf0d1963521e.svg";